webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a
  }]
}));

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(17)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(31),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(3);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Match__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Team__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Team___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Team__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Player__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Meta__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Meta__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {
      msg: 'FFA Brightcove Metadata Helper',
      config: {
        teams: {},
        players: {},
        match: ''
      }
    };
  },
  created: function created() {},

  methods: {
    updateTeams: function updateTeams(data) {
      var self = this;
      self.config.teams = data;
    },
    updatePlayers: function updatePlayers(data) {
      var self = this;
      self.config.players = data;
    },
    updateMatch: function updateMatch(data) {
      var self = this;
      self.config.match = data;
    }
  },
  mounted: function mounted() {},
  components: {
    Match: __WEBPACK_IMPORTED_MODULE_0__components_Match___default.a,
    Team: __WEBPACK_IMPORTED_MODULE_1__components_Team___default.a,
    Player: __WEBPACK_IMPORTED_MODULE_2__components_Player___default.a,
    Meta: __WEBPACK_IMPORTED_MODULE_3__components_Meta___default.a
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'match',
	data: function data() {
		return {
			competitions: [],
			seasons: [],
			matches: [],
			selectedComp: null,
			selectedSeason: '',
			selectedMatch: '',
			compDisplay: 'Choose a competition',
			seasonDisplay: '',
			matchDisplay: ''
		};
	},

	methods: {
		getData: function getData(endpoint, callback) {
			var self = this;
			var xhr = new XMLHttpRequest();
			xhr.open('GET', endpoint, true);
			xhr.send(null);

			xhr.onreadystatechange = function () {
				var DONE = 4,
				    OK = 200;

				if (xhr.readyState === DONE) {
					if (xhr.status === OK) {
						var jsonResponse = JSON.parse(xhr.responseText);
						callback(jsonResponse);
					} else {
						console.log('Error: ' + xhr.status);
					}
				}
			};
		}
	},
	watch: {
		selectedComp: function selectedComp(val, oldval) {
			var self = this;

			if (val != oldval) {
				self.selectedSeason = '';
				self.selectedMatch = '';
				self.seasonDisplay = '';
				self.matchDisplay = '';
			};

			this.getData('https://api.ffa.football/c' + this.selectedComp + '/seasons', function (callback) {
				self.seasons = callback;
			});

			function match(item) {
				return item.id == val;
			}

			self.compDisplay = self.competitions.find(match).name;
			self.seasonDisplay = 'Choose a season';
		},
		selectedSeason: function selectedSeason(val, oldval) {
			var self = this;

			if (val != oldval) {
				self.selectedMatch = '';
				self.matchDisplay = '';
			};

			this.getData('https://api.ffa.football/c' + self.selectedComp + '/s' + self.selectedSeason + '/fixture', function (callback) {
				self.matches = callback;
			});

			function match(item) {
				return item.id == val;
			}

			self.seasonDisplay = self.seasons.find(match).name;
			self.teamDisplay = 'Choose a team';
		},
		selectedMatch: function selectedMatch(val) {
			var self = this;
			this.$emit('matchUpdated', self.selectedMatch);
			var selected = '';
			self.flattenedRounds.forEach(function (rounds) {
				rounds.matches.forEach(function (match) {
					if (match.id == val) {
						selected = match.title;
					};
				});
			});
			self.matchDisplay = selected;
		}
	},
	mounted: function mounted() {
		var self = this;
		this.getData('https://api.ffa.football/competitions', function (callback) {
			self.competitions = callback;
		});
	},
	computed: {
		flattenedRounds: function flattenedRounds() {
			var _rounds = this.matches.rounds;
			var compRounds = [];
			if (_rounds) {
				_rounds.forEach(function (round) {
					var roundNum = round.round_number;
					if (typeof compRounds[roundNum] === 'undefined') {
						compRounds[roundNum] = round.round;
						compRounds[roundNum].matches = [];
					};
					compRounds[roundNum].matches.push(round);
				});
			};
			return compRounds.filter(function () {
				return true;
			});
		}
	}
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Meta',
	data: function data() {
		return {
			copied: false
		};
	},

	props: ['match', 'teams', 'players'],
	methods: {
		copy: function copy() {
			var self = this;
			var elem = document.querySelectorAll('.overflow-cheat');
			var string = elem[0].innerText;
			var textarea = document.createElement('textarea');

			textarea.textContent = string;
			textarea.style.position = 'fixed';
			document.body.appendChild(textarea);

			textarea.select();
			try {
				return document.execCommand("copy");
			} catch (ex) {
				alert("Copy to clipboard failed.", ex);
				return false;
			} finally {
				document.body.removeChild(textarea);
				self.showCopyMessage();
				console.info('Copied successfully.');
			}
		},
		showCopyMessage: function showCopyMessage() {
			var self = this;
			this.copied = true;

			setTimeout(function () {
				self.copied = false;
			}, 2000);
		}
	}
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'player',
	data: function data() {
		return {
			players: [],
			selectedPlayers: []
		};
	},

	methods: {
		getData: function getData(endpoint, callback) {
			var self = this;
			var xhr = new XMLHttpRequest();
			xhr.open('GET', endpoint, true);
			xhr.send(null);

			xhr.onreadystatechange = function () {
				var DONE = 4,
				    OK = 200;

				if (xhr.readyState === DONE) {
					if (xhr.status === OK) {
						var jsonResponse = JSON.parse(xhr.responseText);
						callback(jsonResponse);
					} else {
						console.log('Error: ' + xhr.status);
					}
				}
			};
		},
		compare: function compare(a, b) {
			if (a.name < b.name) {
				return -1;
			}
			if (a.name > b.name) {
				return 1;
			}
			return 0;
		}
	},
	mounted: function mounted() {
		var self = this;
		this.getData('https://api.ffa.football/sync/players', function (callback) {
			self.players = callback;
			//self.selectedPlayers.push(callback[0].id);
		});
	},
	computed: {
		orderedPlayers: function orderedPlayers() {
			return this.players.sort(this.compare);
		}
	},
	watch: {
		selectedPlayers: function selectedPlayers() {
			var self = this;
			this.$emit('playerUpdated', self.selectedPlayers);
		}
	}
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'team',
	data: function data() {
		return {
			teams: [],
			selectedTeams: []
		};
	},

	methods: {
		getData: function getData(endpoint, callback) {
			var self = this;
			var xhr = new XMLHttpRequest();
			xhr.open('GET', endpoint, true);
			xhr.send(null);

			xhr.onreadystatechange = function () {
				var DONE = 4,
				    OK = 200;

				if (xhr.readyState === DONE) {
					if (xhr.status === OK) {
						var jsonResponse = JSON.parse(xhr.responseText);
						callback(jsonResponse);
					} else {
						console.log('Error: ' + xhr.status);
					}
				}
			};
		},
		compare: function compare(a, b) {
			if (a.name < b.name) {
				return -1;
			}
			if (a.name > b.name) {
				return 1;
			}
			return 0;
		}
	},
	mounted: function mounted() {
		var self = this;
		this.getData('https://api.ffa.football/sync/teams', function (callback) {
			self.teams = callback;
			//self.selectedTeams.push(callback[0].id);
		});
	},
	computed: {
		orderedTeams: function orderedTeams() {
			return this.teams.sort(this.compare);
		}
	},
	watch: {
		selectedTeams: function selectedTeams() {
			this.$emit('teamUpdated', this.selectedTeams);
		}
	}
});

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(14)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(28),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(13)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(27),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-229d42f4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(15)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(29),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3fdc1e26",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(16)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(30),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4169f6c2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(12)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(26),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-117d4304",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedTeams),
      expression: "selectedTeams"
    }],
    attrs: {
      "multiple": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedTeams = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.orderedTeams), function(team, index) {
    return _c('option', {
      key: team.id,
      domProps: {
        "value": team.id
      }
    }, [_vm._v("\n\t\t\t" + _vm._s(team.name) + "\n\t\t")])
  })), _vm._v(" "), _c('input', {
    attrs: {
      "type": "",
      "name": "",
      "disabled": ""
    },
    domProps: {
      "value": _vm.selectedTeams
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n\tCompetition\n\t"), _c('div', {
    staticClass: "fake-select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedComp),
      expression: "selectedComp"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedComp = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.competitions), function(comp, index) {
    return _c('option', {
      key: comp.id,
      domProps: {
        "value": comp.id
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(comp.name) + "\n\t\t\t")])
  })), _vm._v(" "), _c('div', {
    staticClass: "initial-option"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.compDisplay) + "\n\t\t")])]), _vm._v("\n\tSeason\n\t"), _c('div', {
    staticClass: "fake-select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedSeason),
      expression: "selectedSeason"
    }],
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedSeason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.seasons), function(season, index) {
    return _c('option', {
      key: season.id,
      domProps: {
        "value": season.id
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(season.name) + "\n\t\t\t")])
  })), _vm._v(" "), _c('div', {
    staticClass: "initial-option"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.seasonDisplay) + "\n\t\t")])]), _vm._v("\n\tMatch\n\t"), _c('div', {
    staticClass: "fake-select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedMatch),
      expression: "selectedMatch"
    }],
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedMatch = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.flattenedRounds), function(round, index) {
    return _c('optGroup', {
      key: round.number,
      attrs: {
        "label": (round.name) ? round.name : round.number
      }
    }, _vm._l((round.matches), function(match) {
      return _c('option', {
        key: match.id,
        domProps: {
          "value": match.id
        }
      }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(match.title) + "\n\t\t\t\t")])
    }))
  })), _vm._v(" "), _c('div', {
    staticClass: "initial-option"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.matchDisplay) + "\n\t\t")])]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "",
      "name": "",
      "disabled": ""
    },
    domProps: {
      "value": _vm.selectedMatch
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "section section--match"
  }, [_c('h2', [_vm._v("Match")]), _vm._v(" "), _c('Match', {
    on: {
      "matchUpdated": _vm.updateMatch
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section section--teams"
  }, [_c('h2', [_vm._v("Teams")]), _vm._v(" "), _c('Team', {
    on: {
      "teamUpdated": _vm.updateTeams
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section section--players"
  }, [_c('h2', [_vm._v("Players")]), _vm._v(" "), _c('Player', {
    on: {
      "playerUpdated": _vm.updatePlayers
    }
  })], 1)]), _vm._v(" "), _c('Meta', {
    attrs: {
      "match": _vm.config.match,
      "teams": _vm.config.teams,
      "players": _vm.config.players
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "output"
  }, [_c('h2', [_vm._v("Configuration string")]), _vm._v(" "), _c('div', {
    staticClass: "string"
  }, [_c('div', {
    staticClass: "overflow-cheat"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.match),
      expression: "match"
    }]
  }, [_vm._v("m" + _vm._s(_vm.match))]), _vm._v(" "), _vm._l((_vm.teams), function(team, index) {
    return [(index == 0) ? _c('span', [_vm._v("t" + _vm._s(team))]) : _c('span', [_vm._v(" t" + _vm._s(team))])]
  }), _vm._v(" "), _vm._l((_vm.players), function(player, index) {
    return [(index == 0) ? _c('span', [_vm._v("p" + _vm._s(player))]) : _c('span', [_vm._v(" p" + _vm._s(player))])]
  })], 2)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.copied) ? _c('div', {
    key: 1,
    staticClass: "copy-success"
  }, [_vm._v("Copied to clipboard")]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "copy",
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("Copy to clipboard")])], 1)
},staticRenderFns: []}

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPlayers),
      expression: "selectedPlayers"
    }],
    attrs: {
      "multiple": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedPlayers = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.orderedPlayers), function(player, index) {
    return _c('option', {
      key: player.id,
      domProps: {
        "value": player.id
      }
    }, [_vm._v("\n\t\t\t" + _vm._s(player.name) + "\n\t\t")])
  })), _vm._v(" "), _c('input', {
    attrs: {
      "type": "",
      "name": "",
      "disabled": ""
    },
    domProps: {
      "value": _vm.selectedPlayers
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ })
],[5]);


// WEBPACK FOOTER //
// static/js/app.38f3f2b8ad5f3c0f7d9a.js